import script from "./training-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./training-modal.vue?vue&type=script&setup=true&lang=js"

import "./training-modal.vue?vue&type=style&index=0&id=408febc6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-408febc6"]])

export default __exports__